// extracted by mini-css-extract-plugin
export default {"swiperSlide":"EffectCardProduct_swiperSlide__d5Qeq","swiper-slide":"EffectCardProduct_swiper-slide__tf7FC"};